import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { getAllMovies } from '../store/actions/todosAction';

import Pagination from '../common/Pagination';
// import { FreeMode,Pagination } from "swiper";
import { Autoplay, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Card } from '../common/Card';
import '../style/MovileList.css';

const CardSlider = () => {
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  const handleResize = () => {
    setScreenSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const { type } = useParams();

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(12);

  const movie = useSelector((state) => state?.movie?.movieList);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllMovies(type ? type : 'popular'));
  }, [type]);

  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentPost = movie?.slice(firstPostIndex, lastPostIndex);

  return (
    <>
      <div className=' bg-colorOne py-20  xl:px-16 px-5 '>
        {/* slider_option */}
        <Swiper
          slidesPerView={
            screenSize > 1200
              ? 6
              : screenSize > 1000
              ? 5
              : screenSize > 800
              ? 4
              : screenSize > 600
              ? 3
              : 3
          }
          spaceBetween={25}
          freeMode={true}
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 1000,
            disableOnInteraction: false,
          }}
          loop={true}
          navigation={true}
          modules={[Autoplay, Pagination, Navigation]}
          className='mySwiper my-5 lg:slides-per-view-6 lg:space-x-4'
        >
          {currentPost?.map((movie, index) => (
            <SwiperSlide key={index}>
              <Card
                movie={movie}
                key={index}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <div className='grid md:justify-items-end justify-items-center py-10'>
          <Link
            to='/movies/popular'
            className='customBtn1 hover:text-amber-400 hover:border-amber-400 '
          >
            View All Movies
          </Link>
        </div>
      </div>
    </>
  );
};

export default CardSlider;
